/**
 * Created by mac on 2018/8/25.
 */
import React, { Component, Fragment } from 'react';
import i18n from 'react-intl-universal';
import styles from './step.scss';
import IconFont from '../Icon/IconFont';

export default class StepTwo extends Component {
  static goUrl() {
    const url = window.location.href;
    window.location.href = `/users/auth/wechat?transfer=true&redirect_url=${encodeURIComponent(url)}`;
  }
  render() {
    const { username, onModalCancelClick } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.title}>
          <div className={styles.index}>2</div>
          <p>解绑「{username}」的微信，并一键绑定到当前账户</p>
        </div>
        <button className={styles.btn} onClick={() => { StepTwo.goUrl(); }}>{i18n.get('bind.yjbdwx')}</button>
        <span className={styles['cancel']} onClick={onModalCancelClick}>{i18n.get('phoneModal.cancel')}</span>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/HasBindMordal/StepTwo.js